import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { trpc } from "@/lib/trpc";
import { Loader2, CheckCircle, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function StaffAccessPage() {
  const [, navigate] = useLocation();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [errorMsg, setErrorMsg] = useState("");

  const accessMutation = trpc.staff.accessByToken.useMutation({
    onSuccess: () => {
      setStatus("success");
      setTimeout(() => {
        navigate("/admin");
        window.location.reload();
      }, 1500);
    },
    onError: (err) => {
      setStatus("error");
      setErrorMsg(err.message);
    },
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setErrorMsg("Link de acesso inválido. Solicite um novo convite ao administrador.");
      return;
    }
    accessMutation.mutate({ token });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-amber-50">
      <div className="bg-white rounded-2xl shadow-lg p-10 max-w-sm w-full text-center">
        {status === "loading" && (
          <>
            <Loader2 className="h-12 w-12 text-amber-600 animate-spin mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Verificando acesso...</h2>
            <p className="text-gray-500 text-sm">Aguarde enquanto validamos seu link de acesso.</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle className="h-12 w-12 text-green-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Acesso confirmado!</h2>
            <p className="text-gray-500 text-sm">Redirecionando para o painel...</p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Link inválido</h2>
            <p className="text-gray-500 text-sm mb-6">{errorMsg}</p>
            <Button
              variant="outline"
              className="border-amber-300 text-amber-700 hover:bg-amber-50"
              onClick={() => navigate("/admin")}
            >
              Ir para o painel
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
